

@if (isReady) {
  <div class="fake-select"
    [ngClass]="{'disabled-area': isDisabled, 'fake-select-colour-icons' : isColourIcons}"
    (keyup)="keyUp($event)"
    id="{{fakeSelectId}}"
    (blur)="onBlur()">
    <div class="form-control"
      [ngClass]="{ 'fake-select__invalid' : isRequired && !model}"
      (click)="clickSelect()"
      id="{{selectId}}"
      #select>
      @if (selectedItem) {
        <div class="fake-select__option"
          >
          @if (selectedItem[imgProp] && isReady) {
            <img [src]="getFullImgUrl(selectedItem)"
              alt="{{selectedItem[altProp]}}">
          }
          @if (selectedItem[sbIconProp]) {
            <sb-icon
              [name]="selectedItem[sbIconProp]"
              [hasColor]="isColourIcons"
              [overrideStyle]="selectedItem[iconStyleProp]"
              [class]="selectedItem[iconClassProp]"
            [isActivity]="selectedItem.iconIsActivity"></sb-icon>
          }
          @if (selectedItem[iconClassProp]) {
            <i
            class="{{selectedItem[iconClassProp]}}"></i>
          }
          @if (!hideSelectedLabel) {
            <span
              [innerHTML]="selectedItem[selectedLabelProp] | translate"
            class="text-capitalize"></span>
          }
        </div>
      }
      @if (!selectedItem) {
        <div [innerHTML]="'SB_Select' | translate"
        ></div>
      }
      <sb-icon name="caretDown"
      class="unclickable"></sb-icon>
    </div>
    @if (show) {
      <div class="fake-select__open"
        id="{{selectInnerId}}"
        #selectInner
        >
        <div class="fake-select__search"
          [hidden]="!showSearch">
          <input type="text"
            class="form-control w-100"
            id="{{searchInputId}}"
            #searchInput
            [(ngModel)]="searchText"
            (focus)="onFocusSearch()"
            placeholder="{{'SB_Search' | translate}}"
            autocomplete="nope">
          </div>
          <div class="fake-select__list"
            [ngClass]="{'fake-select__list-grid' : isGrid}">
            @for (item of filteredOptions(); track item; let i = $index) {
              <div class="form-control-static fake-select__option"
                [ngClass]="{'fake-select__highlighted' : highlightedOptionId === item[idProp]}"
                (click)="onClickItem(item[idProp], $event)"
                (mouseover)="highlightedOptionId = item[idProp]"
                id="fakeSelect-{{id}}-{{item[idProp]}}">
                @if (item[imgProp]) {
                  <img
                    [src]="getFullImgUrl(item)">
                }
                @if (item[sbIconProp]) {
                  <sb-icon
                    [name]="item[sbIconProp]"
                    [hasColor]="isColourIcons"
                    [overrideStyle]="item[iconStyleProp]"
                    [class]="item[iconClassProp]"
                  [isActivity]="item.iconIsActivity"></sb-icon>
                }
                @if (item[iconClassProp]) {
                  <i
                  class="{{item[iconClassProp]}}"></i>
                }
                <span [innerHTML]="item[labelProp] | translate"
                class="text-capitalize"></span>
              </div>
              @if (showOptionDivider(i)) {
                <div>
                  <hr>
                  </div>
                }
              }
            </div>
          </div>
        }
        <input hidden [ngModel]="model">
      </div>
    }
    @if (isLoading || !isReady) {
      <sb-icon name="loading"
      class="pt-5 pl-3"></sb-icon>
    }
